import React from 'react';

import { useAppDispatchers } from '../../../../state/app';
import constants from '../constants';

import { BaseFundingAccountProps, WIDGET_NAME } from '../shared';

import ManualACH from '.';

import { PaymentProps } from './shared';

const { MANUAL_ACH_RULES } = constants;

interface Props extends BaseFundingAccountProps {
  isMorganStanleyFlow?: boolean;
}

export default function ManualAchContainer({
  fundingSource,
  isMorganStanleyFlow,
  getInitialFundingAmount,
  submitPaymentMethod,
  setFundingSource
}: Props) {
  const { createError, answer, getBankName } = useAppDispatchers();

  const createErrorDispatch = (msg: string) => {
    createError({ message: msg, registrationStep: WIDGET_NAME });
  };

  const getBankNameDispatch = (routingNumber: string) => {
    getBankName({ routingNumber });
  };

  const handlePayment = ({
    accountNumber,
    routingNumber,
    nameOnAccount,
    accountType
  }: PaymentProps) => {
    submitPaymentMethod(
      {
        source: 'ach',
        accountNumber,
        routingNumber,
        nameOnAccount,
        accountType,
        loadAmount: getInitialFundingAmount()
      },
      answer
    );
  };

  const isInvalidManualACHAmount = () => {
    const rules = { ...MANUAL_ACH_RULES };
    return getInitialFundingAmount() > rules.maximum;
  };

  return (
    <ManualACH
      fundingSource={fundingSource}
      isMorganStanleyFlow={isMorganStanleyFlow}
      invalidAmountError={isInvalidManualACHAmount()}
      handlePayment={handlePayment}
      createErrorDispatch={createErrorDispatch}
      getBankNameDispatch={getBankNameDispatch}
      setFundingSource={setFundingSource}
    />
  );
}
